// extracted by mini-css-extract-plugin
export var label = "_ay-1";
export var reminder = "_ay-0";